export default __webpack_public_path__ + "static/media/checked-icon.af93e35e.svg";